import { SidebarFooter } from "@/components/ui/sidebar";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getUserFromLocalStorage } from "@/utils/getUserFromLocalStorage";
import LogoutButton from "./logout-button";
import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useUserPhotoQuery } from "@/services/user";
import {
  AVATAR_FALLBACK_TEST_ID,
  AVATAR_IMAGE_TEST_ID,
} from "@/constants/test-ids";

interface SidebarFooterProps {
  userInfo?: { name?: string; email?: string; photo_url?: string | null };
}

export function SidebarFooterComponent({ userInfo }: SidebarFooterProps) {
  const user = useMemo(() => {
    return getUserFromLocalStorage() || {};
  }, []);

  const displayName = userInfo?.name || user?.name || "Usuário";
  const displayEmail = userInfo?.email || user?.email || "";

  // Uma sessão aberta antes do deploy ainda tem o base64 antigo no localStorage; pedir a
  // imagem por ele mandaria a data URL inteira como caminho da requisição.
  const photoUrl = userInfo?.photo_url;
  const { data: photo } = useUserPhotoQuery(
    photoUrl && !photoUrl.startsWith("data:") ? photoUrl : skipToken,
  );

  return (
    <SidebarFooter className="mt-auto bg-gray-50/80 border-t border-gray-200 shrink-0">
      <div className="p-3 space-y-3">
        <div className="flex items-center gap-3">
          <Avatar className="h-10 w-10 border border-gray-200 shadow-sm">
            {photo && (
              <AvatarImage
                data-testid={AVATAR_IMAGE_TEST_ID}
                src={photo}
                alt={displayName}
              />
            )}
            <AvatarFallback
              data-testid={AVATAR_FALLBACK_TEST_ID}
              className="bg-gray-100 text-gray-600 text-sm font-medium"
            >
              {displayName.charAt(0).toUpperCase()}
            </AvatarFallback>
          </Avatar>
          <div className="flex flex-col min-w-0 flex-1">
            <span
              className="text-sm font-medium text-gray-900 truncate"
              title={displayName}
            >
              {displayName}
            </span>
            {displayEmail && (
              <span
                className="text-xs text-gray-500 truncate"
                title={displayEmail}
              >
                {displayEmail}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center justify-between pt-2 border-t border-gray-200">
          <span className="text-[10px] text-gray-400 font-medium">
            Version - {__APP_VERSION__}
          </span>
          <LogoutButton />
        </div>
      </div>
    </SidebarFooter>
  );
}
